import React, { useState } from 'react';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {AccordionSummaryProps} from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material/styles';
import { Icon } from './Icon';

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `none`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));
const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
  marginRight: '15px',
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(-90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));
interface AccordionCustomProps {
  title: any;
  content: any;
  defaultExpanded: boolean;
}

export const AccordionCustom: React.FC<AccordionCustomProps> = ({
  title,
  content,
  defaultExpanded,
}) => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div
      className={`border-b border-l ${
        expanded ? '' : ''
      }`}
    >
      <Accordion
        id="accordion-custom"
        style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
        defaultExpanded={defaultExpanded}
        expanded={expanded === 'panel'}
        onChange={handleChange('panel')}
      >
        <AccordionSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ padding: 0 }}
        >
          {/* <h1
            className={`md:text-base text-gray-600 ${
              expanded ? 'text-bold' : ''
            }`}
          > */}
          {title}
          {/* </h1> */}
        </AccordionSummary>
        <AccordionDetails
          className={`flex flex-col ${expanded ? 'bg-gray-100' : ''}`}
        >
          {/* <div className="whitespace-pre text-gray-600 text-sm transform mt-1 p-3"> */}
          {content}
          {/* </div> */}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
